import { QuickPassPingStatus } from '../../_types/quickpass-ping'
import { StatusPillTone } from './types'

const formatBedBath = (
  bedrooms: number | null,
  bathrooms: number | null,
): string => {
  const parts: string[] = []
  if (bedrooms !== null) {
    parts.push(`${bedrooms} bed${bedrooms === 1 ? '' : 's'}`)
  }
  if (bathrooms !== null) {
    parts.push(`${bathrooms} bath${bathrooms === 1 ? '' : 's'}`)
  }
  return parts.join(' · ')
}

const statusLabel = (status: QuickPassPingStatus): string => {
  if (status === 'pending') {
    return 'New'
  }
  if (status === 'viewed') {
    return 'Open'
  }
  if (status === 'interested') {
    return 'You said yes'
  }
  if (status === 'not-interested') {
    return 'You passed'
  }
  return 'Expired'
}

const isResponded = (status: QuickPassPingStatus): boolean => {
  return (
    status === 'interested' ||
    status === 'not-interested' ||
    status === 'expired'
  )
}

const statusToTone = (status: QuickPassPingStatus): StatusPillTone => {
  if (status === 'pending') {
    return 'pending'
  }
  if (status === 'interested') {
    return 'done'
  }
  if (status === 'not-interested' || status === 'expired') {
    return 'passed'
  }
  return 'viewed'
}

const resolvedNoteFor = (status: QuickPassPingStatus): string => {
  if (status === 'interested') {
    return 'Marked as interested. The agent will reach out.'
  }
  if (status === 'not-interested') {
    return "Passed. The sender doesn't see this."
  }
  return 'This ping has expired.'
}

export {
  formatBedBath,
  statusLabel,
  isResponded,
  resolvedNoteFor,
  statusToTone,
}
